import React, { memo } from 'react';
import { useAppContext } from '../../contexts/AppContext/AppContext';
import { PageManagementBlock } from '../../_blocks/PageManagement';
import { BreadcrumbBlock } from '../../_blocks/Breadcrumb';

export type BreadcrumbSection = {
  blocks: BreadcrumbBlock[];
  uuid: string;
};

export type PageManagementSection = {
  blocks: PageManagementBlock[];
  uuid: string;
};

type BreadcrumbSectionProps = {
  breadcrumb: BreadcrumbSection;
  pageManagement?: PageManagementSection;
};

export const BreadcrumbSection = memo(
  function ({ breadcrumb, pageManagement }: BreadcrumbSectionProps) {
    BreadcrumbSection.displayName = 'BreadcrumbSection';
    const { availableSections } = useAppContext();

    const breadcrumbBlock = breadcrumb.blocks.at(0);
    const pageManagementBlock = pageManagement?.blocks.at(0);
    return (
      <div className="content-main content-main--breadcrumb-section">
        <div className="content-column-two-third">{breadcrumbBlock && <BreadcrumbBlock {...breadcrumbBlock} />}</div>
        {availableSections.pageManagement && (
          <div className="content-column-one-third">
            {pageManagementBlock && <PageManagementBlock {...pageManagementBlock} />}
          </div>
        )}
      </div>
    );
  },
  (prevProps, nextProps) => prevProps.breadcrumb.uuid === nextProps.breadcrumb.uuid
);
